import classNames from 'classnames';
import React from 'react';

import Accordion from '@jpp/molecules/Accordion';
import AcfComponents from '@jpp/organisms/AcfComponents/AcfComponents';
import UpSell from '@jpp/organisms/UpSell';
import Container from '@jpp/shared/Grid/Container';
import Flex from '@jpp/shared/Grid/Flex';
import Row from '@jpp/shared/Grid/Row';
import Section from '@jpp/shared/Grid/Section';
import { EPageType, ETheme } from 'common/typings/enums';
import { IFaqsTemplateProps } from 'common/typings/types';

import './FAQs.scss';

const ROOT_CLASSNAME = 'FAQs';

const FAQs: React.FunctionComponent<IFaqsTemplateProps> = ({ page }) => {
  const { acf_fields, faqs } = page;
  const acf = page.acf || acf_fields;

  return (
    <div className={classNames(ROOT_CLASSNAME)}>
      {acf?.components && (
        <AcfComponents
          pageType={EPageType.Events}
          className={`${ROOT_CLASSNAME}AcfComponents`}
          components={acf?.components}
          page_theme={acf?.page_theme}
        />
      )}

      <Section>
        <Container>
          <Row>
            <Flex colLg={8} className="mx-auto">
              <Accordion faqs={faqs} pageType={EPageType.Faq} />
            </Flex>
          </Row>
        </Container>
      </Section>

      <UpSell
        className={`${ROOT_CLASSNAME}__upsell`}
        theme={ETheme.TintAlpha}
        heading="Check out some of our favourites:"
        shouldHideOOSItems={true}
      />
    </div>
  );
};

export default FAQs;
